let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1h8Cb")).then(() => parcelRequire('2OTd5'));